import { alpha, Box, styled } from "@mui/material";

export const StyledSearchResults = styled(Box)(({ theme }) => ({
  background: `linear-gradient(90deg, ${alpha(
    theme.palette.primary.main,
    0.1,
  )} 0%, ${alpha(theme.palette.primary.main, 0)} 100%)`,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid rgba(201, 211, 244, 0.5)`,
  padding: theme.spacing(1.5),
  overflowWrap: "break-word",
  position: "relative",
  minHeight: theme.spacing(10),
  width: "100%",
}));
